import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn,BootBootstrapButton} from 'react-bootstrap-table';



  
     
  class BSTable extends React.Component {
    constructor(props) {
        super(props);
        
      }
     
      
      
    render() {
      const cellEditProp = {
        mode: 'click',
        blurToSave: true,
        beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
        afterSaveCell: onAfterSaveCell  // a hook for after saving cell
      };

      

      function onBeforeSaveCell(row, cellName, cellValue) {
        // You can do any validation on here for editing value,
        // return false for reject the editing
        //debugger;
        return true;
      }
      function onAfterSaveCell(row, cellName, cellValue) {
        // You can do any validation on here for editing value,
        // return false for reject the editing
       // if(cellName == "action"){
          //console.log('row ='+row+'cellName ='+cellName+'cellValue ='+cellValue);
        //}
        return true;
      }
      

      
      
     
      
      //"Guest"+ (i+1)
      //this.props.data.members[i].first_name,
      //this.props.data.members[i].check_in_date
      //this.props.data.members[i].check_out_date
      
      const guestData = [];        
        for(var i=0; i< this.props.data.no_of_rooms;i++){
          guestData.push ({
              id:this.props.data.id+i,
              guest:"Guest"+ (i+1),                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 
              no_of_rooms: 1,
              check_in_date: this.props.data.members[i].check_in_date,
              check_out_date: this.props.data.members[i].check_out_date,
              action:this.props.data.members[i],
              editMember:this.props.data.members[0].editMember 
          })
        }
         function getRow(cell,row){
          let payload = {check_in_date:row.check_in_date, check_out_date: row.check_out_date}
          row.editMember(cell.id,payload)
          alert("Saved data successfully!");
         }
         function cancelRow(cell,row){
             row.check_in_date = row.action.check_in_date
             row.check_out_date = row.action.check_out_date
         }
         

       const buttonFormatter = (cell, row) => {
          return <div>
                    <Button onClick={() => getRow(cell,row)} style={{'bordercolor': '#5bc0e8 !important;'}}><i className="fa fa-save" ></i></Button>&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button onClick={() => cancelRow(cell,row)} ><i className="fa fa-remove" style={{'border-color': '#5bc0e8;'}}/></Button>
                 </div>;
        };
       
      if (guestData) {
        return (
          <div>
            {/* selectRow={selectRowProp} cellEdit={cellEditProp}*/}
            <BootstrapTable data={ guestData } cellEdit={cellEditProp}>
             <TableHeaderColumn dataField='id' isKey={ true } hidden={true}>Guest id</TableHeaderColumn>
             <TableHeaderColumn dataField='guest' width='100' headerAlign='center' dataAlign='center' editable={{type: 'text'}} >Guest</TableHeaderColumn>
             <TableHeaderColumn dataField='check_in_date'width='100' headerAlign='center' dataAlign='center' editable={ { type: 'date' } }>Check in Date</TableHeaderColumn>
             <TableHeaderColumn dataField='check_out_date'width='100' headerAlign='center' dataAlign='center' editable={ { type: 'date' } }>Check out Date</TableHeaderColumn>
             <TableHeaderColumn dataField='no_of_rooms'width='100' headerAlign='center' dataAlign='center'  editable={ false }>No of Rooms</TableHeaderColumn>
             <TableHeaderColumn dataField='action'width='100' headerAlign='center' dataAlign='center'  dataFormat={buttonFormatter} editable={ false}>Actions</TableHeaderColumn>
            </BootstrapTable> 
          
          </div>
      );
      } else {
        return (<p>?</p>);
      }
    }
  }

  BSTable.propTypes = {
    bid: PropTypes.object,
    tourData: PropTypes.object,
    editMember: PropTypes.func,
  };

export default BSTable;


// WEBPACK FOOTER //
// src/routes/tours/components/BSTable.js